 
import { useState,useEffect } from "react";
import "./SharingAgent.css"
function SharingAgent() {
      const [showShareModal, setShowShareModal] = useState(false);
 
// Prompt States
const [tone, setTone] = useState("Formal");
const [verbosity, setVerbosity] = useState("Low");
const [promptType, setPromptType] = useState("Prompt");
const [systemPrompt, setSystemPrompt] = useState("");
 
// Options
const tones = ["Formal", "Neutral", "Friendly"];
const verbosities = ["Low", "Medium", "High"];
const promptTypes = ["Prompt", "Custom Prompt"];
 
const [hasChanges, setHasChanges] = useState(false);
 
 
// KB Filters
const KB_FILTERS = [
  { key: "type", label: "Type", options: ["Policy", "Guideline"] },
  { key: "department", label: "Department", options: ["HR", "Finance"] },
  { key: "status", label: "Status", options: ["Active", "Inactive"] },
  { key: "access", label: "Access", options: ["Active", "Restricted"] },
];
 
// Empty Doc
const EMPTY_DOC = {
  name: "",
  department: "",
  source: "",
  version: "",
};
// Mark tab as changed
const markTabChanged = () => {
  setHasChanges(true);
};
 
 
// Prompt Update
// const handlePromptUpdate = () => {
//   console.log("Prompt Updated", {
//     tone,
//     verbosity,
//     promptType,
//     systemPrompt,
//   });
// };
 
// KB Source Toggle
const handleSourceToggle = (id) => {
  setKbSources((prev) =>
    prev.map((s) =>
      s.id === id ? { ...s, enabled: !s.enabled } : s
    )
  );
};
 
// KB Filter
const handleFilterChange = (key, value) => {
  setKbFilters((prev) => ({
    ...prev,
    [key]: value,
  }));
};
 
// KB New Doc
const handleNewDocChange = (field, value) => {
  setNewDoc((prev) => ({
    ...prev,
    [field]: value,
  }));
};
 
// KB Update
// const handleKbUpdate = () => {
 
 
//   setTimeout(() => {
//     if (isAddingRow) {
//       setKbDocuments((prev) => [
//         ...prev,
//         {
//           id: Date.now(),
//           ...newDoc,
//           updated: "Just now",
//         },
//       ]);
//     }
 
//     setIsAddingRow(false);
//     setNewDoc(EMPTY_DOC);
   
//   }, 1000);
// };
 
const [editNodeOpen, setEditNodeOpen] = useState(false);
const [nodeName, setNodeName] = useState("");
 
const libraryTools = [
  { name: "Tool 1", icon: "/images/Tool1.svg" },
  { name: "Tool 2", icon: "/images/Tool2.svg" },
  { name: "Tool 3", icon: "/images/Tool3.svg" },
];
 
const handleNodeClick = (name) => {
  setNodeName(name);
  setEditNodeOpen(true);
};
 
const closeEditPanel = () => {
  setEditNodeOpen(false);
};
 
const handleSaveNode = () => {
  console.log("Node saved:", nodeName);
  setEditNodeOpen(false);
};
 
// const handleUpdateWorkflow = () => {
//   console.log("Workflow updated");
// };
 
const [kbSources, setKbSources] = useState([]);
const [kbFilters, setKbFilters] = useState({});
const [kbDocuments, setKbDocuments] = useState([]);
 
const [isAddingRow, setIsAddingRow] = useState(false);
const [isUpdating, setIsUpdating] = useState(false);
 
const [newDoc, setNewDoc] = useState({
  name: "",
  department: "",
  source: "",
  version: "",
});
 
  const [activeTab, setActiveTab] = useState("Basic Information");
 
  const [agent, setAgent] = useState({
    name: "",
    type: "",
    model: "ChatGPT 4.0",
    temperature: 0.5,
    description:
      "Searches and retrieves accurate answers from connected documents, databases, and internal sources with source citations.",
    publishedOn: "",
    updatedOn: "",
    rating: "",
    responseTime: "",
  });
 
  const tabs = [
    "Basic Information",
    "Prompt",
    "Tools",
    "Knowledge Base",
    "Workflow",
  ];
  useEffect(() => {
    // Simulated backend response
    setKbSources([
      { id: 1, name: "Source 1", enabled: true, color: "#22C55E" },
      { id: 2, name: "Source 2", enabled: true, color: "#6366F1" },
      { id: 3, name: "Source 3", enabled: false, color: "#F97316" },
    ]);
 
;
 
    setKbDocuments([
      {
        id: 1,
        name: "Leave Policy – 2025.pdf",
        department: "HR",
        source: "Sharepoint",
        version: "v3.1",
        updated: "2 days ago",
      },
      {
        id: 2,
        name: "Leave Policy – 2025.pdf",
        department: "HR",
        source: "Vector DB",
        version: "v3.1",
        updated: "2 days ago",
      },
    ]);
  }, []);
const agentMetaConfig = [
  { key: "publishedOn", label: "Published On" },
  { key: "updatedOn", label: "Last Updated On" },
  { key: "rating", label: "Rating" },
  { key: "responseTime", label: "Response Time" },
];
const handleGlobalUpdate = () => {
  console.log("Saving All Tabs...");
 
  const payload = {
    agent,
    prompt: {
      tone,
      verbosity,
      promptType,
      systemPrompt,
    },
    knowledgeBase: kbDocuments,
    workflow: nodeName,
  };
 
  console.log("Final Payload:", payload);
 
  // TODO: API call later
 
  setHasChanges(false);
};
 
  return (
    <div className="d-flex ">
 
    <div className="flex-grow-1 d-flex flex-column overflow-auto sa-page-bg">
 
 
 
        <div className="p-4">
          <div className="bg-white rounded-3 shadow-sm">
          <div className="px-4 py-3 rounded-top sa-about-header">
 
              <h6 className="fw-semibold mb-0">About</h6>
            </div>
 
            <div className="p-4">
              <p className="text-muted mb-4">{agent.description}</p>
 
              <div className="d-flex justify-content-between align-items-center flex-wrap">
       <div className="d-flex gap-5 flex-wrap">
  {agentMetaConfig.map((item) => (
    <Meta
      key={item.key}
      label={item.label}
      value={agent[item.key]}
    />
  ))}
</div>
 
 
                <div className="d-flex align-items-center gap-2">
            <button className="btn px-4 sa-primary-btn">
 
                    Chat
                  </button>
 <div className="dropdown">
        <button
          className="btn btn-light"
          data-bs-toggle="dropdown"
        >
          <i className="bi bi-three-dots-vertical"></i>
        </button>
 
        <ul className="dropdown-menu">
          <li>
            <button
              className="dropdown-item"
              onClick={() => setShowShareModal(true)}
            >
              Share
            </button>
          </li>
          <li>
            <button className="dropdown-item text-danger">
              Delete
            </button>
          </li>
        </ul>
      </div>
       {showShareModal && (
        <ShareModal onClose={() => setShowShareModal(false)} />
      )}
 
     
 
                </div>
              </div>
            </div>
          </div>
        </div>
 
       
        <div className="p-4 pt-0 bottmpad">
          <div className="bg-white rounded-3 shadow-sm">
     
         <div className=" rounded-top sa-tabs-header">
 
              <ul className="nav nav-tabs border-0">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab}>
  <button
    className={`nav-link border-0 sa-tab-btn ${
      activeTab === tab
        ? "bg-white fw-semibold  text-active rounded-top"
        : "text-dark"
    }`}
    onClick={() => setActiveTab(tab)}
  >
    {tab}
  </button>
</li>
 
                ))}
              </ul>
            </div>
 
            <div className="">
 
              {activeTab === "Basic Information" && (
                <div className="row g-4 p-4">
                  <Input
                    label="Agent Name"
                    value={agent.name}
                onChange={(e) => {
  setAgent({ ...agent, name: e.target.value });
markTabChanged();
 
 
}}
 
                  />
                  <div className="col-md-6">
                    <label className="form-label text-muted">Type</label>
 
                    <select
                      className="form-select sa-grey-input"
                      value={agent.type || ""}
                     onChange={(e) => {
  setAgent({ ...agent, type: e.target.value });
markTabChanged();
 
 
}}
 
                    >
                      {/* Placeholder (shows only initially) */}
                      <option value="" disabled hidden>
                        Select Type
                      </option>
 
                      <option value="HR">HR</option>
                      <option value="Finance">Finance</option>
                      <option value="Legal">Legal</option>
                      <option value="IT">IT</option>
                      <option value="Operations">Operations</option>
                    </select>
 
                  </div>
 
 
 
                  <div className="col-md-6">
                    <label className="form-label text-muted">LLM Model</label>
                    <select
                      className="form-select sa-grey-input"
                      value={agent.model}
                     onChange={(e) => {
  setAgent({ ...agent, model: e.target.value });
markTabChanged();
 
 
}}
 
                    >
 
                      <option>ChatGPT 4.0</option>
<option>gpt-4o-mini</option>
 
                      <option>GPT-4 Turbo</option>
                      <option>GPT-3.5</option>
                    </select>
                  </div>
 
                  <div className="col-md-6">
                    <label
                      className="form-label-custom"
                      style={{ color: "#030b18", fontWeight: "500" }}
                    >
                      Temperature
 
                    </label>
 
                    <input
                      type="range"
                      name="temperature"
                      className="slider-blue"
                      min="0"
                      max="1"
                      step="0.1"
                      // value={agent.temperature}
                    onChange={(e) => {
  setAgent({
    ...agent,
    temperature: parseFloat(e.target.value),
  });
markTabChanged();
 
 
}}
 
                      style={{
                        background: `linear-gradient(
      to right,
      #00008B 0%,
      #00008B ${agent.temperature * 100}%,
      #E5E7EB ${agent.temperature * 100}%,
      #E5E7EB 100%
    )`,
                      }}
                    />
 
                  </div>
 
                  <div className="col-12">
                    <label className="form-label text-muted">Description</label>
                    <textarea
                      className="form-control sa-grey-input"
                      rows="4"
                      // value={agent.description}
                      placeholder="Description"
                     onChange={(e) => {
  setAgent({ ...agent, description: e.target.value });
markTabChanged();
 
 
}}
 
                    />
 
                  </div>
                </div>
              )}
 
{activeTab === "Prompt" && (
  <>
    {/* Top Controls */}
    <div className="row g-4 p-4">
      <div className="col-md-6">
        <label className="form-label text-muted">Tone</label>
        <select
          className="form-select formss-select6"
          value={tone}
        onChange={(e) => {
  setTone(e.target.value);
markTabChanged();
 
 
}}
 
        >
          {tones
            .filter((item) => item !== tone)
            .map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
 
          <option value={tone} hidden>
            {tone}
          </option>
        </select>
      </div>
 
      <div className="col-md-6">
        <label className="form-label text-muted">Verbosity</label>
        <select
          className="form-select formss-select6"
          value={verbosity}
          onChange={(e) => {
  setVerbosity(e.target.value);
markTabChanged();
 
 
}}
 
        >
          {verbosities
            .filter((item) => item !== verbosity)
            .map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
 
          <option value={verbosity} hidden>
            {verbosity}
          </option>
        </select>
      </div>
 
      <div className="col-md-6">
        <label className="form-label text-muted">Prompt</label>
        <select
          className="form-select formss-select6"
          value={promptType}
         onChange={(e) => {
  setPromptType(e.target.value);
markTabChanged();
 
 
}}
 
        >
          {promptTypes
            .filter((item) => item !== promptType)
            .map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
 
          <option value={promptType} hidden>
            {promptType}
          </option>
        </select>
      </div>
    </div>
 
    {/* System Prompt Box (Always Visible) */}
    <div className="mb-4 p-4">
      <label className="form-label text-muted">System Prompt</label>
 
      <div className="position-relative sa-prompt-box">
        <textarea
          className="form-control border-0 sa-prompt-textarea"
          rows="6"
          placeholder="Prompt"
          value={systemPrompt}
onChange={(e) => {
  setSystemPrompt(e.target.value);
markTabChanged();
 
}}
 
        />
      </div>
    </div>
 
 
  </>
)}
 
    {activeTab === "Tools" && (
            <div className="row g-0 sa-tools-wrapper">
 
              <div className="col-md-2 border-end sa-tools-sidebar">
                <div className="p-3 fw-semibold small">Tool Library</div>
 
                {libraryTools.map((tool) => (
                  <div
                    key={tool.name}
                    className="d-flex align-items-center justify-content-between px-3 py-2 border-top"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img src={tool.icon} alt={tool.name} width="18" height="18" />
 
                      <span
                        className="sa-tool-dot"
                        style={{ backgroundColor: tool.color }}
                      />
 
                      <small>{tool.name}</small>
                    </div>
 
                    <button className="btn btn-sm btn-light">+</button>
                  </div>
                ))}
              </div>
 
              <div className="col-md-10 bg-white">
                {libraryTools.slice(0, 2).map((tool) => (
                  <div
                    key={tool.name}
                    className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img src={tool.icon} alt={tool.name} width="18" height="18" />
 
                      <span
                        className="sa-kb-dot"
                        style={{ backgroundColor: tool.color }}
                      />
 
 
                      <span className="fw-normal">{tool.name}</span>
                    </div>
 
                    <button className="btn btn-light btn-sm">
                      <img src="images/wrench.svg" alt="" />
                    </button>
                  </div>
                ))}
              </div>
 
 
 
            </div>
          )}
                {activeTab === "Knowledge Base" && (
            <div className="row g-0 sa-kb-wrapper" >
 
 
              <div className="col-md-2 border-end p-0 sa-kb-sidebar">
 
                <div className="px-3 py-2 fw-semibold small border-bottom">
                  Source Integration
                </div>
 
                {kbSources.map((src) => (
                  <div
                    key={src.id}
                    className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="sa-kb-dot"
                        style={{ backgroundColor: src.color }}
                      />
                      <small>{src.name}</small>
                    </div>
 
                    <div className="form-check form-switch m-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={src.enabled}
                     onChange={() => {
  handleSourceToggle(src.id);
markTabChanged();
 
 
 
}}
 
 
                      />
                    </div>
                  </div>
                ))}
              </div>
 
 
              <div className="col-md-10 p-0 d-flex flex-column">
 
                {/* DOCUMENT HEADER */}
                <div className="px-4 py-2 fw-semibold small border-bottom d-flex justify-content-between align-items-center add-buttonshare">
                  <span>Documents</span>
                  <button
                    className="btn btn-link button-line fw-semibold p-0"
                    onClick={() => setIsAddingRow(true)}
                  >
                    + New
                  </button>
 
                </div>
 
                {/* CONTENT */}
                <div className="p-4 flex-grow-1 sa-kb-content">
 
 
                  <div className="d-flex gap-3 flex-wrap mb-4">
                    <div className="d-flex gap-3 flex-wrap mb-4">
                      {KB_FILTERS.map((filter) => {
 
                        const selectedValue = kbFilters[filter.key] || "";
 
                        return (
                          <select
                            key={filter.key}
                            className="form-select sa-kb-filter"
                            value={selectedValue}
                        onChange={(e) => {
  handleFilterChange(filter.key, e.target.value);
markTabChanged();
 
 
}}
 
                          >
 
                            {/* Show other options */}
                            {filter.options
                              .filter((opt) => opt !== selectedValue)
                              .map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
 
                            {/* Hidden selected option (like Prompt tab) */}
                            {selectedValue && (
                              <option value={selectedValue} hidden>
                                {selectedValue}
                              </option>
                            )}
 
                            {/* Placeholder when empty */}
                            {!selectedValue && (
                              <option value="" hidden>
                                {filter.label}
                              </option>
                            )}
 
                          </select>
                        );
                      })}
 
                    </div>
 
 
 
                  </div>
 
 
 
 
                  <div className="table-responsive">
                    <table className="table align-middle mb-0">
                      <thead className="sa-kb-table-head">
                        <tr>
                          <th className="sa-kb-checkbox-col">
                            <input type="checkbox" />
                          </th>
                          <th>Document Name</th>
                          <th>Department</th>
                          <th>Source</th>
                          <th>Version</th>
                          <th>Last updated</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
 
                      <tbody>
                        {kbDocuments.map((doc) => (
                          <tr key={doc.id}>
                            <td>
                              <input type="checkbox" />
                            </td>
                            <td className="text-primary">{doc.name}</td>
                            <td>{doc.department}</td>
                            <td>{doc.source}</td>
                            <td>{doc.version}</td>
                            <td>{doc.updated}</td>
                            <td className="text-center">
                              <i className="bi bi-eye text-primary"></i>
                            </td>
                          </tr>
                        ))}
 
                        {isAddingRow && (
                          <tr className="sa-kb-new-row">
                            <td />
 
                            <td>
                              <input
                                className="form-control form-control-sm"
                                placeholder="Document name"
                                value={newDoc.name}
                             onChange={(e) => {
  handleNewDocChange("name", e.target.value);
markTabChanged();
 
 
}}
 
                              />
                            </td>
 
                            <td>
                              <input
                                className="form-control form-control-sm"
                                placeholder="Department"
                                value={newDoc.department}
                             onChange={(e) => {
  handleNewDocChange("department", e.target.value);
markTabChanged();
 
 
}}
 
 
                              />
                            </td>
 
                            <td>
                              <input
                                className="form-control form-control-sm"
                                placeholder="Source"
                                value={newDoc.source}
                               
  onChange={(e) => {
  handleNewDocChange("source", e.target.value)
markTabChanged();
 
 
}}
                              />
                            </td>
 
                            <td>
                              <input
                                className="form-control form-control-sm"
                                placeholder="Version"
                                value={newDoc.version}
                             
                             
  onChange={(e) => {
  handleNewDocChange("version", e.target.value)
markTabChanged();
 
 
}}
                              />
                            </td>
 
                            <td>-</td>
 
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-link text-danger"
                                onClick={() => {
                                  setIsAddingRow(false);
                                  setNewDoc(EMPTY_DOC);
 
                                }}
                              >
                                Cancel
                              </button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
           
                </div>
 
 
 
 
              </div>
            </div>
          )}
 
             {activeTab === "Workflow" && (
  <>
    <div className="workflow-container">
 
      {/* Sidebar */}
      <div className="workflow-sidebar">
 
        <div className="sidebar-section">
          <div className="section-header">Add</div>
          <p className="section-description">
            Drag nodes to the pane on the right to build your workflow.
            <br />
            To remove: Click on a node and press Backspace.
          </p>
        </div>
 
        <div className="sidebar-section">
          <div className="section-header">Tools</div>
          {libraryTools.map((tool, i) => (
            <div key={i} className="tool-item">
              <img src={tool.icon} width="18" height="18" />
              <span className="tool-name">{tool.name}</span>
            </div>
          ))}
        </div>
 
        <div className="sidebar-section">
          <div className="section-header">Nodes</div>
          {[
            { name: "Question Node", icon: "/images/Start.svg" },
            { name: "Condition Node", icon: "/images/Condition.svg" },
            { name: "End Node", icon: "/images/End.svg" },
          ].map((n, i) => (
            <div
              key={i}
              className="node-item"
              onClick={() => handleNodeClick(n.name)}
            >
              <img src={n.icon} width="18" height="18" />
              <span className="node-name">{n.name}</span>
            </div>
          ))}
        </div>
 
      </div> {/* END sidebar */}
 
 
      {/* Canvas */}
      <div className="workflow-canvas">
 
        {/* Title */}
        <div className="canvas-title-wrapper">
          <div className="canvas-title">Workflow</div>
        </div>
 
        {/* Divider */}
        <div className="canvas-divider"></div>
 
        {/* Zoom Buttons */}
        <div className="zoom-wrapper">
          <div className="zoom-controls">
            <button className="btn-zoom">−</button>
            <button className="btn-zoom">+</button>
          </div>
        </div>
 
        {/* Content */}
        <div className="workflow-content">
 
          <div
            className="node-box start-node" style={{ width: "clamp(60px, 70%, 130px)" }}
 
            onClick={() => handleNodeClick("Start")}
          >
            <img src="/images/Start.svg" width="28" height="28" />
            <span className="node-name fs-6">Start</span>
          </div>
 
          <div className="node-connector-wrapper">
            <div className="connector-circle top"></div>
            <div className="node-connector-line"></div>
            <div className="connector-circle bottom"></div>
          </div>
 
          <div
            className="node-box question-node"style={{ width: "clamp(60px, 70%, 130px)" }}
 
            onClick={() => handleNodeClick("Question")}
          >
            <img src="/images/Question.svg" width="28" height="28" />
            <span className="node-name fs-6 ">Question</span>
          </div>
 
        </div>
 
      </div> {/* END canvas */}
 
 
      {/* Edit Panel */}
      <div className={`edit-node-panel ${editNodeOpen ? "open" : ""}`}>
 
        <div className="panel-header">
          <div className="panel-title">Edit Node</div>
          <button className="btn-close" onClick={closeEditPanel}></button>
        </div>
 
        <div className="panel-content">
          <label className="form-label">Node Name</label>
          <input
            className="form-control"
            value={nodeName}
            onChange={(e) => {
              setNodeName(e.target.value);
          markTabChanged();
 
            }}
          />
        </div>
 
        <div className="panel-footer">
          <button className="btn-save" onClick={handleSaveNode}>
            Save Changes
          </button>
        </div>
 
      </div> {/* END edit panel */}
 
    </div> {/* ✅ VERY IMPORTANT — closes workflow-container */}
 
  </>
)}
            </div>
{hasChanges && (
  <div
    style={{
      position: "fixed",
      bottom: 0,
      left: "100px", // sidebar width
      right: "25px",
      background: "#fff",
      borderTop: "1px solid #e5e7eb",
      boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
      zIndex: 9999,
    }}
  >
   <div
  style={{
    padding: "16px 24px",
    width: "100%",
  }}
>
 
   <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  }}
>
 
      <button
  className="btn sa-primary-btn px-4"
  onClick={handleGlobalUpdate}
>
  Update
</button>
 
      </div>
    </div>
  </div>
)}
           
          </div>
 
 
 
 
        </div>
      </div>
    </div>
  );
}
 
function ShareModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const isValidNameOrEmail = (value) => {
    if (!value) return false;
 
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[a-zA-Z\s]{2,}$/;
 
    return emailRegex.test(value) || nameRegex.test(value);
  };
  return (
<>
  <div className="sa-modal-overlay">
    <div className="sa-modal-container">
 
      <div className="sa-modal-header">
        <h5 className="sa-modal-title">Share Agent</h5>
        <button className="sa-modal-close" onClick={onClose}>
          ×
        </button>
      </div>
 
      <div className="sa-modal-body">
 
        <div className="sa-form-group">
          <label className="sa-form-label">Name</label>
 
          <div className="sa-input-group">
            <input
              type="text"
              placeholder="Add Name, or Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="sa-input"
            />
 
            <button
              type="button"
              className="sa-icon-btn"
              title="View access"
            >
              👁
            </button>
 
            <span className="sa-divider" />
 
            <button
              type="button"
              className="sa-icon-btn"
              title="Permission"
            >
              ▾
            </button>
          </div>
        </div>
 
        <div className="sa-form-group">
          <label className="sa-form-label">Message</label>
          <textarea
            rows={3}
            placeholder="Add message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="sa-textarea"
          />
        </div>
      </div>
 
      <div className="sa-modal-footer">
        <button
          className="sa-share-btn"
          disabled={!isValidNameOrEmail(email)}
          onClick={() => {
            console.log({ email, message });
            onClose();
          }}
        >
          Share
        </button>
      </div>
 
    </div>
  </div>
 
  <div className="sa-modal-backdrop" onClick={onClose} />
</>
 
  );
}
 
function Meta({ label, value }) {
  return (
    <div>
      <small className="text-muted">{label}</small>
      <div className="fw-semibold">
  {value !== "" && value !== null && value !== undefined ? value : "-"}
</div>
 
    </div>
  );
}
 
function Input({ label, value, onChange, type = "text" }) {
  return (
    <div className="col-md-6">
      <label className="form-label text-muted">{label}</label>
      <input
        type={type}
        className="form-control controlform-chat"
   
        value={value}
        onChange={onChange}
      />
    </div>
   
  );
}
 
export default SharingAgent;
 
 